/**
 * 分钟盘是否应自动纠到 clock live。
 *
 * - 非 5m：到期后自动纠正（settle 中由调用方拦截）
 * - 5m：到期先停留展示结算；**仅裁决出结果后**（judged）再自动进实时盘，
 *   避免倒计时归零瞬间与交易区/结算区打架；手动「前往实时盘口」仍可用
 *
 * @param {number|string} intervalSec
 * @param {{ judged?: boolean }} [opts]
 */
export function shouldAutoNavigateUpdownToLive(intervalSec, opts = {}) {
  const interval = Number(intervalSec);
  if (!Number.isFinite(interval) || interval <= 0) return false;
  if (interval === 5 * 60) return Boolean(opts?.judged);
  return true;
}
